<template>
    <Dropdown
        class="country-dropdown"
        v-model="selectedCountry"
        panel-class="order-time-dropdown-panel scrollable-element"
        :options="currentOptions"
        optionLabel="label"
        optionValue="value"
        :disabled="props.disabled"
        scrollHeight="300px"
    />
</template>

<script setup lang="ts">
    import { Country } from "@/data/model/Enums";
    import { translations } from "@/shared/localization/translations";
    import { computed, ref, watch } from "vue";

    import Dropdown from "primevue/dropdown";

    // define props
    const props = defineProps<{
        modelValue: Country | null;
        disabled: boolean;
        inputId?: string;
    }>();

    // define emits
    const emit = defineEmits(["update:modelValue"]);

    // define state
    const selectedCountry = ref(props.modelValue ?? Country.Switzerland);

    // define computed
    const currentOptions = computed(() => {
        let countries = Array<Country>();
        countries.push(Country.Switzerland);

        return countries.map((c) => {
            return {
                label: translations.enums.Country[Country[c]],
                value: c,
            };
        });
    });

    // event handlers
    watch(selectedCountry, (newSelectedTime) => {
        emit("update:modelValue", newSelectedTime);
    });

    // update watchers
    watch(
        () => props.modelValue,
        (newSelectedTime) => {
            selectedCountry.value = newSelectedTime ?? Country.Switzerland;
        }
    );
</script>

<style lang="scss">
    @use "./../../../assets/styles/scss/shared/_colors.scss";

    .country-dropdown {
        text-align: left;
        color: colors.$fontColor;
        min-width: 100px;
        border-radius: 4px;
        box-shadow: none !important;
        width: 300px;
        display: inline-flex;
        cursor: pointer;
        position: relative;
        user-select: none;

        .p-dropdown-label {
            display: block;
            white-space: nowrap;
            overflow: hidden;
            flex: 1 1 auto;
            width: 1%;
            text-overflow: ellipsis;
            cursor: pointer;
        }

        .p-dropdown-trigger {
            display: flex;
            align-items: center;
            justify-content: center;
            flex-shrink: 0;
        }

        > .p-inputtext {
            padding: 0.5em;
            font-size: 16px !important;
        }
    }

    .order-time-dropdown-panel {
        .p-dropdown-items {
            .p-dropdown-item {
                color: colors.$fontColor;
                border-bottom: 1px solid colors.$greyBorder !important;
                padding: 0.75em 1em;

                &:last-child {
                    border-bottom: none !important;
                }
            }
        }
    }
</style>
